import React, { Component } from 'react';
import './form-result.css';
import  { connect } from 'react-redux';
import Input from '../customInputs';
import SubmitButton from '../customInputs/submitButton';
import { INPUT_TYPES } from '../../config/constants';
import { handleFormSubmit, mapSubmitData } from './form-result.helper';
import { formSubmitMethods } from './form-submit-methods';
import { showErrorAlert } from '../../redux/actions/alert';
import { ResultPageWrapper } from '../resultPageWrapper';
import { AppModal } from '../customInputs/AppModal';


class FormResult extends Component {

    constructor(props) {
        super(props);

        this.containerRef = React.createRef();
    }

    state = {
        submitClicked: false,
        formIsValid: true,
        loading: false,
        showFormPopup: this.props.formPopup && this.props.formPopup.enabled
    }

    handleSubmit = async () => {
        const { result, filesForUpload, passwordItem, hasValidationErrors, useDefaultPass } = handleFormSubmit(this.props.inputWithProps);

        this.setState({
            submitClicked: true,
            formIsValid: !hasValidationErrors,
            loading: !hasValidationErrors
        });

        const conf = mapSubmitData({
            result,
            filesForUpload,
            formId: window.RESULT_FORM_PAGE_CONFIG.formId
        });

        if (hasValidationErrors) {

            setTimeout(_ => {
                this.containerRef.current.scrollTo({
                    top: this.containerRef.current.scrollHeight,
                    behavior: 'smooth'
                });
            }, 0);
            return;
        }

        let registrationData = [];

        if (
            'RESULT_FORM_PAGE_CONFIG' in window && passwordItem &&
            (window.RESULT_FORM_PAGE_CONFIG.isRegistForm || window.RESULT_FORM_PAGE_CONFIG.isConfirmationForm)
        ) {
            conf['password'] = passwordItem;
            conf['useDefaultPass'] = useDefaultPass;
            if (!window.RESULT_FORM_PAGE_CONFIG.duuzraId) {
                this.props.showErrorAlert('Duuzra Id is empty!');
                this.setState({ loading: false });
                return;
            } else {

                let type;
                if (window.RESULT_FORM_PAGE_CONFIG.isRegistForm) {
                    type = 'registration';
                }
                if (window.RESULT_FORM_PAGE_CONFIG.isConfirmationForm) {
                    type = 'confirmation'
                }
                const email = conf.result.find((el) => el.type === INPUT_TYPES.EMAIL);

                if (!email || !email.value) {
                    this.props.showErrorAlert('Email is required');
                    return;
                }

                registrationData = formSubmitMethods.registerFeedback({
                    email,
                    conf,
                    type,
                    registUrl: window.RESULT_FORM_PAGE_CONFIG.registUrl,
                    duuzraId: window.RESULT_FORM_PAGE_CONFIG.duuzraId
                });

            }
        }

        conf['registrationData'] = registrationData;

        formSubmitMethods.sendForm(conf)
            .then(res => {
                console.log('res', res);
                this.handleRedirects(conf);
            })
            .catch(e => {
                console.log('ERROR', e);
                let errorMessage;
                if (e && e.hasOwnProperty('message')) {
                    errorMessage = e.message
                } else if (typeof e === 'string') {
                    errorMessage = e;
                } else {
                    errorMessage = "Something went wrong";
                }
                this.props.showErrorAlert(errorMessage);
            })
            .finally(_ => {
                this.setState({ loading: false });
            })
    }

    handleRedirects = (conf) => {
        if (conf.isFromDownloader && conf.files) {
            window.location.replace(conf.url + '?autodownloading=' + conf.autoDownloading + '&files=' + conf.files + '&send-email=' + conf.sendEmail);
        } else {
            window.location.replace('/feedback-result/' + conf.formId + '/success');
        }
    }

    onCloseFormPopup = (val) => {
        if (val) {
            this.setState({ showFormPopup: false });
        }
    }

    render() {
        const { typeIds, targetBuilderType, colors, bgImage, isSuccessPage, formPopup } = this.props;
        const submitButtonIsAdded = typeIds[targetBuilderType].findIndex(el => el.type === INPUT_TYPES.SUBMIT_BUTTON) !== -1;
        return (
            <>
                {
                    this.state.showFormPopup &&
                        <AppModal
                            showInnerModalOnDecline={true}
                            showModal={this.state.showFormPopup}
                            onCloseModal={this.onCloseFormPopup}
                            config={formPopup}
                        />
                }
                <ResultPageWrapper
                    backgroundImage={bgImage}
                    targetBuilderType={targetBuilderType}
                    colors={colors}
                    isFullScreen={true}
                    hideResultContainer={this.state.showFormPopup}
                >
                    <div
                        ref={this.containerRef}
                        className={`form-container ${this.state.submitClicked ? 'touched' : ''}`}
                    >
                        {
                            typeIds[targetBuilderType].map((item) => (
                                <Input
                                    key={item.id}
                                    color={colors[targetBuilderType].elementColor}
                                    textColor={colors[targetBuilderType].textColor}
                                    initialValues={item}
                                    isResultInput={true}
                                    formIsValid={this.state.formIsValid}
                                    handleSubmit={this.handleSubmit}
                                    loadingSubmit={this.state.loading}
                                />
                            ))
                        }
                        {
                            !isSuccessPage &&
                            (
                                !submitButtonIsAdded &&
                                <>
                                    <SubmitButton
                                        formIsValid={this.state.formIsValid}
                                        loadingSubmit={this.state.loading}
                                        initialValues={{}}
                                        isResultInput={true}
                                        handleSubmit={this.handleSubmit}
                                    />
                                </>
                            )
                        }

                    </div>
                </ResultPageWrapper>

            </>
        );
    }
}

export default connect(
    state => ({
        bgImage: state.bgImage,
        typeIds: state.typeId,
        colors: state.colors,
        inputWithProps: state.inputWithProps,
    }),
    {
        showErrorAlert,
    }
  )(FormResult);
